import type { ISchoolClassroomRepository } from '@/core/domain/school/classroom/ISchoolClassroomRepository'
import type { SchoolClassroomLoginHistory } from '@/core/domain/school/classroom/SchoolClassroomLoginHistory'

export default class FetchSchoolClassroomLoginHistoryUseCase {
  private schoolClassroomRepository: ISchoolClassroomRepository

  constructor(schoolClassroomRepository: ISchoolClassroomRepository) {
    this.schoolClassroomRepository = schoolClassroomRepository
  }

  async execute(
    schoolId: number,
    schoolPeriodId: number,
    schoolClassroomId: number
  ): Promise<SchoolClassroomLoginHistory> {
    return await this.schoolClassroomRepository.fetchSchoolClassroomLoginHistory(
      schoolId,
      schoolPeriodId,
      schoolClassroomId
    )
  }
}
